/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AddFreshdeskPhotoEvidenceRequest,
  AddFreshdeskPhotoEvidencesParams,
  AddFreshdeskPhotoEvidencesResponse,
  CancelOutboundRequestResponse,
  CreateOutboundPhotoRequestParams,
  DeleteMeterReadingPhotoEvidenceParams,
  GenerateMeterReadingPhotoEvidenceGetUrlParams,
  GetErroredReadingSubmissionsResponse,
  GetMeterReadingPhotoEvidenceListParams,
  GetMeterReadingPhotoEvidenceResponse,
  GetMeterReadingPhotoEvidenceUploadUrlResponse,
  GetMeterReadingPhotoEvidenceUploadUrlsListParams,
  MeterReadingPhotoEvidenceSignedUpGetUrl,
  OutboundFollowUpResponse,
  OutboundPhotoRequest,
  OutboundPhotoResponse,
  ResolveReadingSubmissionParams,
  ResolveSubmissionResponse,
  SendFollowUpEmailForOutboundRequestParams,
  SubmitMeterReadingRequest,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Submit a meter reading for a given billing account id.
 */
export const submitMeterReading = (
  billingAccountId: number,
  submitMeterReadingRequest: SubmitMeterReadingRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/${billingAccountId}/meterReading`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitMeterReadingRequest,
    },
    options,
  )
}
/**
 * @summary Resolve a meter reading submission error.
 */
export const resolveReadingSubmission = (
  params: ResolveReadingSubmissionParams,
  options?: SecondParameter<
    typeof backofficeRequest<ResolveSubmissionResponse>
  >,
) => {
  return backofficeRequest<ResolveSubmissionResponse>(
    { url: `/meterReading/resolveReadingSubmission`, method: "POST", params },
    options,
  )
}
/**
 * @summary Delete a meter reading photo evidence.
 */
export const deleteMeterReadingPhotoEvidence = (
  params: DeleteMeterReadingPhotoEvidenceParams,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    { url: `/meterReading/photoEvidence/delete`, method: "DELETE", params },
    options,
  )
}
/**
 * @summary Return errored meter reading submissions
 */
export const getErroredReadingSubmissions = (
  options?: SecondParameter<
    typeof backofficeRequest<GetErroredReadingSubmissionsResponse>
  >,
) => {
  return backofficeRequest<GetErroredReadingSubmissionsResponse>(
    { url: `/meterReading/errored`, method: "GET" },
    options,
  )
}
/**
 * @summary Generate meter read photo evidence signed up url.
 */
export const generateMeterReadingPhotoEvidenceGetUrl = (
  params: GenerateMeterReadingPhotoEvidenceGetUrlParams,
  options?: SecondParameter<
    typeof backofficeRequest<MeterReadingPhotoEvidenceSignedUpGetUrl>
  >,
) => {
  return backofficeRequest<MeterReadingPhotoEvidenceSignedUpGetUrl>(
    { url: `/meterReading/photoEvidence/url`, method: "GET", params },
    options,
  )
}
/**
 * @summary Get meter read photo evidence list.
 */
export const getMeterReadingPhotoEvidenceList = (
  params: GetMeterReadingPhotoEvidenceListParams,
  options?: SecondParameter<
    typeof backofficeRequest<GetMeterReadingPhotoEvidenceResponse>
  >,
) => {
  return backofficeRequest<GetMeterReadingPhotoEvidenceResponse>(
    { url: `/meterReading/photoEvidence`, method: "GET", params },
    options,
  )
}
/**
 * @summary Add freshdesk photo evidences.
 */
export const addFreshdeskPhotoEvidences = (
  addFreshdeskPhotoEvidenceRequest: AddFreshdeskPhotoEvidenceRequest[],
  params: AddFreshdeskPhotoEvidencesParams,
  options?: SecondParameter<
    typeof backofficeRequest<AddFreshdeskPhotoEvidencesResponse>
  >,
) => {
  return backofficeRequest<AddFreshdeskPhotoEvidencesResponse>(
    {
      url: `/meterReading/photoEvidence`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addFreshdeskPhotoEvidenceRequest,
      params,
    },
    options,
  )
}
/**
 * @summary Get meter read photo evidence upload urls list.
 */
export const getMeterReadingPhotoEvidenceUploadUrlsList = (
  params: GetMeterReadingPhotoEvidenceUploadUrlsListParams,
  options?: SecondParameter<
    typeof backofficeRequest<GetMeterReadingPhotoEvidenceUploadUrlResponse>
  >,
) => {
  return backofficeRequest<GetMeterReadingPhotoEvidenceUploadUrlResponse>(
    { url: `/meterReading/photoEvidence/upload`, method: "GET", params },
    options,
  )
}
/**
 * @summary Create outbound photo request.
 */
export const createOutboundPhotoRequest = (
  outboundPhotoRequest: OutboundPhotoRequest,
  params: CreateOutboundPhotoRequestParams,
  options?: SecondParameter<typeof backofficeRequest<OutboundPhotoResponse>>,
) => {
  return backofficeRequest<OutboundPhotoResponse>(
    {
      url: `/meterReading/createOutboundPhotoRequest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: outboundPhotoRequest,
      params,
    },
    options,
  )
}
/**
 * @summary Send follow-up email for outbound request.
 */
export const sendFollowUpEmailForOutboundRequest = (
  outboundRequestId: number,
  params: SendFollowUpEmailForOutboundRequestParams,
  options?: SecondParameter<typeof backofficeRequest<OutboundFollowUpResponse>>,
) => {
  return backofficeRequest<OutboundFollowUpResponse>(
    {
      url: `/meterReading/sendFollowUpEmailForOutboundRequest/${outboundRequestId}`,
      method: "POST",
      params,
    },
    options,
  )
}
/**
 * @summary Cancel outbound request.
 */
export const cancelOutboundRequest = (
  outboundRequestId: number,
  options?: SecondParameter<
    typeof backofficeRequest<CancelOutboundRequestResponse>
  >,
) => {
  return backofficeRequest<CancelOutboundRequestResponse>(
    {
      url: `/meterReading/cancelOutboundRequest/${outboundRequestId}`,
      method: "POST",
    },
    options,
  )
}
export type SubmitMeterReadingResult = NonNullable<
  Awaited<ReturnType<typeof submitMeterReading>>
>
export type ResolveReadingSubmissionResult = NonNullable<
  Awaited<ReturnType<typeof resolveReadingSubmission>>
>
export type DeleteMeterReadingPhotoEvidenceResult = NonNullable<
  Awaited<ReturnType<typeof deleteMeterReadingPhotoEvidence>>
>
export type GetErroredReadingSubmissionsResult = NonNullable<
  Awaited<ReturnType<typeof getErroredReadingSubmissions>>
>
export type GenerateMeterReadingPhotoEvidenceGetUrlResult = NonNullable<
  Awaited<ReturnType<typeof generateMeterReadingPhotoEvidenceGetUrl>>
>
export type GetMeterReadingPhotoEvidenceListResult = NonNullable<
  Awaited<ReturnType<typeof getMeterReadingPhotoEvidenceList>>
>
export type AddFreshdeskPhotoEvidencesResult = NonNullable<
  Awaited<ReturnType<typeof addFreshdeskPhotoEvidences>>
>
export type GetMeterReadingPhotoEvidenceUploadUrlsListResult = NonNullable<
  Awaited<ReturnType<typeof getMeterReadingPhotoEvidenceUploadUrlsList>>
>
export type CreateOutboundPhotoRequestResult = NonNullable<
  Awaited<ReturnType<typeof createOutboundPhotoRequest>>
>
export type SendFollowUpEmailForOutboundRequestResult = NonNullable<
  Awaited<ReturnType<typeof sendFollowUpEmailForOutboundRequest>>
>
export type CancelOutboundRequestResult = NonNullable<
  Awaited<ReturnType<typeof cancelOutboundRequest>>
>
